import { render, staticRenderFns } from "./tkt.vue?vue&type=template&id=874c2a6a&"
import script from "./tkt.vue?vue&type=script&lang=js&"
export * from "./tkt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports